import { Injectable } from '@angular/core';

import {planosStorage, referenciaTempo} from "./data.service";
import {UtilService} from "../../../shared/services/util.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class PlanoService {

    constructor(
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(planosStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(planosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(planosStorage + "-new");
    }

    //others
    getReferenciaTempo(refId: number) {
        let list: any[] = this._utilService.cloneObject(referenciaTempo),
            x: number, lenX: number,
            ref: any;

        for (x = 0, lenX = list.length; x < lenX; x++) {
            if (list[x].Key === refId) {
                ref = list[x];
                break;
            }
        }

        return ref;
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    if (state.titulo) {
                        text = state.titulo;
                    }
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/shared/plano.service.ts
 **/